export default __webpack_public_path__ + "static/media/COM-BNB.63f3d874.png";